import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";

import { Formik } from "formik";
import * as Yup from "yup";

import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import {
	Box, Typography, Grid, Paper, TextField, Icon
} from "@material-ui/core";

import PayrollStyle from "./payrollStyle";
import lockImage from "../../assets/images/lock.png";

import * as routes from "../../constants/routes";
import * as stpActions from "../../actions/STPActions";
import * as employerActions from "../../actions/EmployerActions";


import { DialogCommonComponent } from "../common";

class ModalSTPDeclaration extends Component {
	state = {
		openCongratulation: false,
		showPopup: false
	};

	validationSchema = Yup.object({
		signature: Yup.string()
			.required("Signature is required")
			.test("match", "Signature not is valid.", (signature) => {
				const { authorizedName } = this.props;

				return authorizedName.toLowerCase() === signature.toLowerCase();
			})
	});

	handleSubmitSTP = (value, actions) => {
		const { sendSTP, stpSummary, history } = this.props;
		actions.setSubmitting(false);

		const valuesSend = {
			id: stpSummary.id,
			authorizedName: value.signature
		};

		sendSTP(valuesSend, history);
		this.setState({ showPopup: true });
	};

	redirectToPayroll = () => {
		const { history } = this.props;
		this.setState({ openCongratulation: false });

		history.push(routes.PATH_PAYROLL);
	};

	componentWillReceiveProps = (nextProps) => {
		const { isSendToSTP, authorizedName, getAuthorizedPerson } = nextProps;
		const { showPopup } = this.state;

		if (isSendToSTP && showPopup) {
			this.setState({ openCongratulation: true, showPopup: false });
		}

		if (authorizedName == undefined || authorizedName == "") {
			getAuthorizedPerson();
		}
	};

	renderForm = (formProps) => {
		const {
			classes, open, onCloseModal, employer, authorizedName
		} = this.props;
		const { openCongratulation } = this.state;

		return (
			<DialogCommonComponent title="STP Declaration"
				style2={{ textAlign: 'center', letterSpacing: 0, color: "#ffffff", opacity: 1, fontSize: "15px", fontWeight: "bold", fontFamily: 'AvenirNextLTPro-Demi' }}
				style={{ borderRadius: 5 }} size="lg" showDivider primaryButtonName="Lodge STP with ATO" onPrimaryButtonClick={formProps.handleSubmit} open={open} onCloseModal={onCloseModal} primaryButtonDisabled={!formProps.isValid}>
				<Grid container direction="row" className={classes.signatureContainer}>
					<Grid item xs={12}>
						<Typography variant="body1" gutterBottom className={classes.centerText}>
							{/* {"EASY PAYSLIP PTY LTD"} */}
							{employer.company.abn.name ? employer.company.abn.name : employer.companyName}
							<br />
							{`${employer.company.address.addressLine1}, ${employer.company.address.townCity}, ${employer.company.address.state} ${employer.company.address.postCode}`}
							{/* {"Suite 7/701/ Military Road, Mosman NSW 2088"} */}
							<br />
							<br />
							{`I, ${authorizedName || '(loading...)'}, declare the information transmited in this payroll report is true and correct and I am authorised to make this declaration`}
							<br />
							<br />
							{"By entering my name below and clicking the 'Lodge STP File with ATO' button below, I authorise lodgement with Easy Payslip's approved sending service provider's Auskey."}
						</Typography>
					</Grid>
					<Box m={2} />
					<Grid container direction="row" alignItems="center" justify="center">
						<Grid item xs={2}>
							<Typography variant="body1" className={classes.centerText}>
								{"Signature"}
							</Typography>
						</Grid>
						<Grid item xs={3}>
							<Paper className={clsx(classes.paperGridNotPadding)}>
								<TextField
									id="signature"
									label="Type your name here"
									className={clsx(classes.textField, {
										error: formProps.errors.signature && formProps.touched.signature
									})}
									variant="filled"
									fullWidth
									value={formProps.values.signature}
									onChange={formProps.handleChange}
									onBlur={formProps.handleBlur}
								/>
							</Paper>
						</Grid>
						<Grid item xs={1}>
							{!formProps.isValid ? <img className={classes.iconInTop} src={lockImage} alt="" /> : <Icon className={clsx(classes.checkIcon, { active: formProps.isValid })}>{formProps.isValid ? "check_circle" : "cancel"}</Icon>}
						</Grid>
					</Grid>
				</Grid>

				{openCongratulation ? (
					<DialogCommonComponent title="Send to STP" size="xs" open={openCongratulation} onCloseModal={this.redirectToPayroll} primaryButtonName="Ok" onPrimaryButtonClick={this.redirectToPayroll}>
						<Typography variant="h2">STP file sent.</Typography>
					</DialogCommonComponent>
				) : null}
			</DialogCommonComponent>
		);
	};

	render() {
		return <Formik initialValues={{ signature: "" }} validationSchema={this.validationSchema} onSubmit={this.handleSubmitSTP} render={this.renderForm} enableReinitialize />;
	}
}

ModalSTPDeclaration.propTypes = {
	employer: PropTypes.object,
	authorizedName: PropTypes.string,
	stpSummary: PropTypes.object,

	sendSTP: PropTypes.func,
	isSendToSTP: PropTypes.bool
};

const mapStateToProps = state => {
	console.log(state);

	return ({
		authorizedName: state.session.authorizedName ? state.session.authorizedName : (state.session.userData.company ? (state.session.userData.company.authorizedPerson || {}).fullName : ""),
		employer: state.session.userData,
		stpSummary: state.stp.reportSummary,
		isSendToSTP: state.stp.isSendToSTP
	})
};

const mapDispatchToProps = dispatch => ({
	sendSTP: bindActionCreators(stpActions.sendSTPRequest, dispatch),
	getAuthorizedPerson: bindActionCreators(employerActions.getAuthorizedPerson, dispatch)
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(withStyles(PayrollStyle)(ModalSTPDeclaration)));
